import Vue from 'vue';
import * as utils from '../util/utils';

export default {
  install() {
    Vue.helpers = utils;
    Vue.prototype.$helpers = utils;
  },
};
